import React, { useContext } from 'react';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import ComponentItemRenderProd from './ComponentItemRenderProd';
import { observer } from 'mobx-react-lite';
// import styles from './index.module.scss';

const PageContentRenderProd = observer(() => {
  const pageEditorStore = useContext(PageEditorStoreContext);

  return (
    <div>
      <div >
        {pageEditorStore?.page['elements']?.map((item) => {
          return <ComponentItemRenderProd key={item.nodeId} {...item} />;
        })}
      </div>
      {/* <div className="mo-elements">
        {pageEditorStore?.page['moElements']?.map((item) => {
          return <ComponentItemRenderProd key={item.nodeId} {...item} />;
        })}
      </div> */}

    </div>
  );
});

export default PageContentRenderProd;
